export const GET_CONTENT = "GET_CONTENT";
export const ADD_CONTENT = "ADD_CONTENT";
export const UPDATE_CONTENT = "UPDATE_CONTENT";
export const DELETE_CONTENT = "DELETE_CONTENT";
export const ADD_HISTORY = "ADD_HISTORY";

// filters
export const TOGGLE_TAGS = "TOGGLE_TAGS";
export const TOGGLE_SORT = "TOGGLE_SORT";

// sorts